<template>
    <div class="conference-section" v-if="items.length">
        <section-header title="Conferences" icon="fa-screen-users" :to="{name: 'registrations'}" :link-text="registrations ? 'All Conference Records (' + registrations.length + ')' : 'All conference records'"/>
        <!-- The very same card as the Conference Records page -->
        <registration v-for="r in items" :key="r.id" :registration="r" class="mb-4"/>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import SectionHeader from "../framework/SectionHeader";
    import Registration from "../Registration";

    /**
     * Live and upcoming conference registrations, then recently finished
     * ones that still have something outstanding. Hidden when there is
     * nothing current — the Conference Records page owns the archive.
     *
     * The feed decides WHICH registrations belong here; the rows themselves
     * come from the registrations store (the same rows the Conference
     * Records page renders), so the card is shared.
     */
    export default {
        name: "ConferenceSection",
        components: {SectionHeader, Registration},
        props: {
            limit: {type: Number, default: 4},
        },
        computed: {
            ...mapGetters(['dashboardConferences', 'registrations']),
            items() {
                const c = this.dashboardConferences;
                if (!c || !Array.isArray(this.registrations)) return [];
                const recent = (c.recent_past || []).filter(r =>
                    r.state === 'po_pending' || r.open_apps > 0 || (r.outstanding && r.outstanding.log_unsigned));
                const byId = new Map(this.registrations.map(r => [r.id, r]));
                return [...(c.in_progress || []), ...(c.upcoming || []), ...recent]
                    .map(entry => byId.get(entry.registration_id))
                    .filter(Boolean)
                    .slice(0, this.limit);
            }
        }
    };
</script>
